import { memo } from "react";
import Columns from "./Columns";
import type { ColumnsProps } from "./types";

const Previous = (props: ColumnsProps) => (
    <Columns
        {...props}
        getComparisonColumn={({ previous }) => previous}
    />
);

export default memo(Previous);
